import { z } from 'zod';

export const paymentProvider = z.enum(['vipps', 'stripe']);
export type PaymentProvider = z.infer<typeof paymentProvider>;

export const checkoutRequest = z.object({
  provider: paymentProvider,
});
export type CheckoutRequest = z.infer<typeof checkoutRequest>;

export const checkoutResponse = z.object({
  /** Where the client should send the browser to complete payment. */
  redirectUrl: z.string(),
  purchaseId: z.string().uuid(),
});
export type CheckoutResponse = z.infer<typeof checkoutResponse>;

/** Price is fixed in v1 (PLAN: ~50 kr one-time). */
export const PRICE_NOK = 49;
